<template>
  <v-layout
    class="pa-4"
    column
  >
    <v-layout justify-space-between row>
      <v-flex class="header ml-5">
        <h1 class="title -tongue">
          Olá, <strong>{{username}}</strong>.
          Você tem {{ amount.total }} intimaç{{ amount.total !== 1 ? 'ões' : 'ão' }}:
        </h1>
      </v-flex>

      <v-flex v-if="isAdmin">
        <v-layout row justify-end align-center>
          <v-btn color="primary" :to="{ name: 'Nova Intimação' }">
            <v-icon left>mdi-plus-circle-outline</v-icon>
            <span class="text">Nova Intimação</span>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row justify-start class="mt-4">
      <v-layout align-center>
        <filter-cards
          v-if="amount.total"
          @changeActive="toggleActive"
          :cards="cards"
        />
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import FilterCards from '@/components/application/list/FilterCards';
import colors from 'vuetify/es5/util/colors';
import { isEqual, findIndex } from 'lodash';

export default {
  name: 'SubpoenasHeader',
  components: {
    FilterCards,
  },
  data() {
    return {
      username: JSON.parse(localStorage.getItem('user')).name,
    };
  },
  props: {
    subpoenas: {
      type: Array,
      default: () => [],
    },
    activeStatus: {
      type: String,
      default: '',
    },
    amount: {
      type: Object,
    }
  },
  methods: {
    toggleActive(card) {
      const newActiveItemIndex = findIndex(this.cards, ['title', card.title]);
      this.cards[newActiveItemIndex].active = true;
      this.$emit('activeStatusChanged', card.status);
    },
  },
  computed: {
    cards() {
      return [
        {
          title: 'TODOS',
          status: '',
          amount: this.amount.total,
          borderColor: colors.grey.base,
          backgroundColor: colors.grey.lighten2,
          active: isEqual(this.activeStatus, ''),
        },
        {
          title: 'A ENVIAR',
          status: 'waiting_to_be_sent',
          amount: this.amount.waiting_to_be_sent,
          borderColor: colors.grey.base,
          backgroundColor: colors.grey.lighten2,
          active: isEqual(this.activeStatus, 'waiting_to_be_sent'),
        },
        {
          title: 'EM ANÁLISE',
          status: 'waiting_for_review',
          amount: this.amount.waiting_for_review,
          borderColor: colors.amber.base,
          backgroundColor: colors.amber.lighten5,
          active: isEqual(this.activeStatus, 'waiting_for_review'),
        },
        {
          title: 'VENCIDO',
          status: 'expired',
          amount: this.amount.expired,
          borderColor: colors.red.base,
          backgroundColor: colors.red.lighten5,
          active: isEqual(this.activeStatus, 'expired'),
        },
      ];
    },
    isAdmin(){
      return this.$route.meta.userType === 'Admin';
    },
  },
};
</script>